class LocalizationSwitchForm extends HTMLElement {
    constructor() {
        super();
        this.langCodeSwitchMappings = {
            // From : To
            'ja' : 'en',
            'en' : 'ja',
        };
        this.form = this.querySelector('form');
        this.addEventListener('click', (event) => this.formSubmit());
    }

    get availableLanguages() {
        const jsonVal = this.getAttribute('data-available-languages');
        return JSON.parse(jsonVal);
    }

    get langCodeElement() {
        return this.querySelector('input[name="language_code"]');
    }

    formSubmit() {
        this.langCodeElement.value = this.switchLangCode(this.langCodeElement.value);
        this.form.submit();
    }

    switchLangCode(from) {
        const to = this.langCodeSwitchMappings[from];
        return to ?? 'ja';
    }
}

customElements.define('localization-switch-form', LocalizationSwitchForm);